export default "__VITE_ASSET__BhwD7SWK__"